import { useState, useEffect } from 'react';
import { useSettings } from '@wix/tpa-settings/react';
import settingsParams from '../../settingsParams';

export const usePagination = (totalItems: number) => {
  const settings = useSettings();
  const pageSize = settings.get(settingsParams.sessionsPerPage) || 10;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    setCurrentPage((prev) => Math.min(prev, totalPages - 1));
  }, [totalPages]);

  const onPageChange = (page: number) => {
    setCurrentPage(Math.max(0, Math.min(page, totalPages - 1)));
  };

  return {
    currentPage,
    totalPages,
    pageSize,
    onPageChange,
  };
};
